var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import { BCard, BCardHeader, BCollapse, BIconGrid3x3Gap, BIconChat, BIconBell, BIconGear, BIconPeople, BIconInfoSquare, BNavItem } from 'bootstrap-vue';
import NavSection from './NavSection.vue';
import NavItem from './NavItem.vue';
import Badge from '@/modules/main/components/Badge.vue';
import FIconActivities from '@/modules/main/components/icons/FIconActivities.vue';
import FIconChats from '@/modules/main/components/icons/FIconChats.vue';
import FIconSettings from '@/modules/main/components/icons/FIconSettings.vue';
import FIconInfo from '@/modules/main/components/icons/FIconInfo.vue';
import FIconNotifications from '@/modules/main/components/icons/FIconNotifications.vue';
import FIconNeighbours from '@/modules/main/components/icons/FIconNeighbours.vue';
import FIconSurrounding from '@/modules/main/components/icons/FIconSurrounding.vue';
import FIconGroups from '@/modules/main/components/icons/FIconGroups.vue';
import FIconClubs from '@/modules/main/components/icons/FIconClubs.vue';
import FIconBusiness from '@/modules/main/components/icons/FIconBusiness.vue';
import FIconInstitution from '@/modules/main/components/icons/FIconInstitution.vue';
import FIconMembers from '@/modules/main/components/icons/FIconMembers.vue';
import MembershipSelect from "@/modules/main/components/groups/MembershipSelect.vue";
import { getRouteNameFromSection } from '@/utils/links';
var SideNav = /** @class */ (function (_super) {
    __extends(SideNav, _super);
    function SideNav() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeSection = 'section-1';
        _this.staticSection = ['fuerenand', 'belvita'];
        _this.isCommunityInformationPage = false;
        _this.isNeighbourhoodInformationPage = false;
        return _this;
    }
    SideNav.prototype.onSectionChange = function () {
        if (this.activeSection === 'section-1' || this.activeSection === 'section-2' || this.activeSection === 'section-3') {
            this.$router.push({ name: getRouteNameFromSection(this.activeSection) }).catch(function () { });
        }
        else if (this.activeSection === 'section-4') {
            this.$router.push({ name: getRouteNameFromSection(this.activeSection), params: { groupId: this.groupId.toString() } }).catch(function () { });
        }
    };
    SideNav.prototype.activateSection = function (section) {
        this.activeSection = section;
        this.onSectionChange();
    };
    Object.defineProperty(SideNav.prototype, "user", {
        get: function () {
            return this.session.user;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SideNav.prototype, "userIsLoggedIn", {
        get: function () {
            var _a;
            return !!((_a = this.user) === null || _a === void 0 ? void 0 : _a.id);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SideNav.prototype, "currentGroupId", {
        get: function () {
            var _a, _b;
            if (!this.$route.params.groupId) {
                return Number((_b = (_a = this.user) === null || _a === void 0 ? void 0 : _a.groups) === null || _b === void 0 ? void 0 : _b.slice(0, 1).map(function (group) {
                    return group.id;
                }));
            }
            return parseInt(this.$route.params.groupId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SideNav.prototype, "platform", {
        get: function () {
            var _a;
            return (_a = this.user) === null || _a === void 0 ? void 0 : _a.neighbourhood;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SideNav.prototype, "hasCommunity", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.user) === null || _a === void 0 ? void 0 : _a.community) !== null && _b !== void 0 ? _b : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SideNav.prototype, "isGroupMember", {
        get: function () {
            var _a, _b;
            var groupsLength = (_b = (_a = this.user) === null || _a === void 0 ? void 0 : _a.groups) === null || _b === void 0 ? void 0 : _b.length;
            return groupsLength && groupsLength > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SideNav.prototype, "isGroupAdmin", {
        get: function () {
            var _this = this;
            var _a, _b;
            return !!((_b = (_a = this.user) === null || _a === void 0 ? void 0 : _a.groups) === null || _b === void 0 ? void 0 : _b.find(function (group) {
                var _a, _b;
                return group.id == _this.currentGroupId && ((_a = group.contact_person) === null || _a === void 0 ? void 0 : _a.id) === ((_b = _this.user) === null || _b === void 0 ? void 0 : _b.id);
            }));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SideNav.prototype, "isGroupModerator", {
        get: function () {
            var _this = this;
            var _a, _b;
            return !!((_b = (_a = this.user) === null || _a === void 0 ? void 0 : _a.groups) === null || _b === void 0 ? void 0 : _b.find(function (group) {
                var _a;
                return group.id == _this.currentGroupId &&
                    ((_a = group.moderator) === null || _a === void 0 ? void 0 : _a.find(function (user) {
                        var _a;
                        return user.user.id === ((_a = _this.user) === null || _a === void 0 ? void 0 : _a.id);
                    }));
            }));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SideNav.prototype, "unreadMessagesCount", {
        get: function () {
            var _a, _b;
            if (((_a = this.user) === null || _a === void 0 ? void 0 : _a.unread_messages_count) !== undefined) {
                return (_b = this.user) === null || _b === void 0 ? void 0 : _b.unread_messages_count;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SideNav.prototype, "isPlatformAdmin", {
        get: function () {
            var _this = this;
            var _a, _b;
            return !!((_b = (_a = this.user) === null || _a === void 0 ? void 0 : _a.platforms) === null || _b === void 0 ? void 0 : _b.find(function (platform) {
                var _a, _b, _c;
                return platform.id == ((_b = (_a = _this.user) === null || _a === void 0 ? void 0 : _a.neighbourhood) === null || _b === void 0 ? void 0 : _b.id) &&
                    ((_c = platform.admin) === null || _c === void 0 ? void 0 : _c.find(function (user) {
                        var _a;
                        return user.user.id === ((_a = _this.user) === null || _a === void 0 ? void 0 : _a.id);
                    }));
            }));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SideNav.prototype, "isPlatformModerator", {
        get: function () {
            var _this = this;
            var _a, _b;
            return !!((_b = (_a = this.user) === null || _a === void 0 ? void 0 : _a.platforms) === null || _b === void 0 ? void 0 : _b.find(function (platform) {
                var _a, _b, _c;
                return platform.id == ((_b = (_a = _this.user) === null || _a === void 0 ? void 0 : _a.neighbourhood) === null || _b === void 0 ? void 0 : _b.id) &&
                    ((_c = platform.moderator) === null || _c === void 0 ? void 0 : _c.find(function (user) {
                        var _a;
                        return user.user.id === ((_a = _this.user) === null || _a === void 0 ? void 0 : _a.id);
                    }));
            }));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SideNav.prototype, "group", {
        get: function () {
            var _this = this;
            var _a, _b;
            if (this.isGroupMember) {
                return (_b = (_a = this.user) === null || _a === void 0 ? void 0 : _a.groups) === null || _b === void 0 ? void 0 : _b.find(function (group) { return Number(group.id) === _this.currentGroupId; });
            }
        },
        enumerable: false,
        configurable: true
    });
    SideNav.prototype.checkCommunityInformationPage = function () {
        this.isCommunityInformationPage = window.location.pathname.startsWith("/gemeinden/");
    };
    SideNav.prototype.checkNeighbourhoodInformationPage = function () {
        this.isNeighbourhoodInformationPage = window.location.pathname.startsWith("/nachbarschaften/");
    };
    SideNav.prototype.isCurrentUrl = function (url) {
        return url === window.location.pathname;
    };
    SideNav.prototype.onRouteChange = function () {
        var _a, _b, _c;
        var sectionFromRoute = (_a = this.$route.meta) === null || _a === void 0 ? void 0 : _a.sideNav;
        if (sectionFromRoute) {
            this.activeSection = sectionFromRoute;
        }
        this.groupId = parseInt(this.$route.params.groupId);
        if (!this.groupId) {
            this.groupId = Number((_c = (_b = this.user) === null || _b === void 0 ? void 0 : _b.groups) === null || _c === void 0 ? void 0 : _c.slice(0, 1).map(function (group) {
                return group.id;
            }));
        }
        this.checkCommunityInformationPage();
        this.checkNeighbourhoodInformationPage();
        // Event für Mobile-Menü senden
        this.$root.$emit('hideShowMenuClass');
    };
    SideNav.prototype.onMembershipChange = function (groupId) {
        this.groupId = groupId;
        this.$router.push({ name: 'membership.activities', params: { groupId: groupId.toString() } }).catch(function () { });
    };
    SideNav.prototype.mounted = function () {
        var _a;
        if (!((_a = this.$route.meta) === null || _a === void 0 ? void 0 : _a.sideNav)) {
            var staticUrl = window.location.pathname.split('/')[1];
            if (this.staticSection.includes(staticUrl)) {
                this.activeSection = staticUrl;
            }
            this.checkCommunityInformationPage();
            this.checkNeighbourhoodInformationPage();
        }
    };
    __decorate([
        Inject(),
        __metadata("design:type", Object)
    ], SideNav.prototype, "session", void 0);
    __decorate([
        Watch('$route'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SideNav.prototype, "onRouteChange", null);
    SideNav = __decorate([
        Component({
            components: {
                Badge: Badge,
                FIconInstitution: FIconInstitution,
                FIconBusiness: FIconBusiness,
                FIconClubs: FIconClubs,
                FIconGroups: FIconGroups,
                FIconSurrounding: FIconSurrounding,
                FIconNeighbours: FIconNeighbours,
                FIconNotifications: FIconNotifications,
                FIconInfo: FIconInfo,
                FIconSettings: FIconSettings,
                FIconChats: FIconChats,
                FIconActivities: FIconActivities,
                FIconMembers: FIconMembers,
                BCard: BCard,
                BCardHeader: BCardHeader,
                BCollapse: BCollapse,
                NavSection: NavSection,
                BIconGrid3x3Gap: BIconGrid3x3Gap,
                BIconChat: BIconChat,
                BIconBell: BIconBell,
                BIconGear: BIconGear,
                BIconPeople: BIconPeople,
                BIconInfoSquare: BIconInfoSquare,
                NavItem: NavItem,
                MembershipSelect: MembershipSelect,
                BNavItem: BNavItem,
            },
        })
    ], SideNav);
    return SideNav;
}(Vue));
export default SideNav;
